import { render, staticRenderFns } from "./ProfileCompetencies.vue?vue&type=template&id=3bc7562a&scoped=true"
import script from "./ProfileCompetencies.vue?vue&type=script&lang=js"
export * from "./ProfileCompetencies.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompetencies.vue?vue&type=style&index=0&id=3bc7562a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7562a",
  null
  
)

export default component.exports